module.exports = __webpack_public_path__ + "static/media/money-bag.f2e357fa.png";